import React from 'react';

import './SellTradeDateReviewRow.scss';

import SellProjectedDate from '../SellProjectedDate/SellProjectedDate';
import SellTransactionEstimation from '../SellTransactionEstimation/SellTransactionEstimation';

const SellTradeDateReviewRow = ({
  deliveryMethod,
  displayTradeDate,
  isTakeHomeEstimated,
  sellTakeHomeAmount,
  sellTotalAmount,
}) => (
  <div className="col-md-12 col-sm-12 col-xs-12 sell-trade-date-review-row-projected-trade-date">
    <SellProjectedDate
      displayTradeDate={displayTradeDate}
      isTakeHomeEstimated={isTakeHomeEstimated}
      sellTakeHomeAmount={sellTakeHomeAmount}
      sellTotalAmount={sellTotalAmount}
    />
    <SellTransactionEstimation deliveryMethod={deliveryMethod} isMobile />
  </div>
);

export default SellTradeDateReviewRow;
